import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Products from "../pages/products/page";
import ProductDetail from "../pages/product-detail/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import AdminLogin from "../pages/admin/login/page";
import AdminProducts from "../pages/admin/products/page";
import AdminMessages from "../pages/admin/messages/page";
import AdminScheduler from "../pages/admin/scheduler/page";
import AdminDefinitions from "../pages/admin/definitions/page";
import Legal from "../pages/legal/page";
import ProtectedRoute from "../components/feature/ProtectedRoute";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/products/:id",
    element: <ProductDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/legal",
    element: <Legal />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin",
    element: <ProtectedRoute><AdminProducts /></ProtectedRoute>,
  },
  {
    path: "/admin/products",
    element: <ProtectedRoute><AdminProducts /></ProtectedRoute>,
  },
  {
    path: "/admin/messages",
    element: <ProtectedRoute><AdminMessages /></ProtectedRoute>,
  },
  {
    path: "/admin/definitions",
    element: <ProtectedRoute><AdminDefinitions /></ProtectedRoute>,
  },
  {
    path: "/admin/scheduler",
    element: <ProtectedRoute><AdminScheduler /></ProtectedRoute>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;